
import React, { useState } from 'react';
import { useGlobalContext } from '../GlobalContext';


const KeperiodeLalu = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const { periodeakun, bulan, api } = useGlobalContext();

  // validasi periodeakun sebelum pakai
  if (!periodeakun) return <div>Loading...</div>;

  // parse YYYYMM secara aman
  const year = periodeakun.substring(0, 4);
  const month = parseInt(periodeakun.substring(4, 6), 10); // 1..12

  // display for current periode (use 0-based index for bulan array)
  const currentPeriodeDisplay = (!isNaN(month) && month >= 1 && month <= 12)
    ? `${bulan[month - 1]} ${year}`
    : '';

  // hitung prev month/year dan format prevPeriode seperti YYYYMM
  let prevMonth = !isNaN(month) ? month - 1 : NaN; // 1..12
  let prevTahun = year;
  if (!isNaN(prevMonth) && prevMonth <= 0) {
    prevMonth = 12; // Desember
    prevTahun = (parseInt(year, 10) - 1).toString();
  }

  const prevPeriode = (!isNaN(prevMonth) && prevTahun)
    ? `${prevTahun}${String(prevMonth).padStart(2, '0')}`
    : '';
  const prevPeriodeDisplay = (!isNaN(prevMonth) && prevTahun)
    ? `${bulan[prevMonth - 1]} ${prevTahun}`
    : '';

  console.log('Periode Akun:', periodeakun);
  console.log('Periode Sebelumnya:', prevPeriode);

  // async handler untuk tombol
  const handleProses = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const status = 1; // aktifkan periode sebelumnya
    const prevperiode = true;
    if (!prevPeriode) { setMessage('Periode invalid'); setIsSubmitting(false); return; }
    await api.delete(`/api/akuntansi/rekeningperkiraan/${periodeakun}`);
    try {
      await api.delete(`/api/akuntansi/periode/${periodeakun}`); // optional, sesuai kode user
    } catch(e){ console.warn(e); }
    try {
      await api.patch(`/api/akuntansi/rekeningperkiraanstatus/${prevPeriode}/${status}`);
    } catch(e) {
      console.error('Gagal update status rekening perkiraan:', e);
      setMessage('Gagal update status rekening perkiraan: ' + (e?.response?.data?.message || e.message));
      setIsSubmitting(false);
      return;
    }
    try {
      await api.patch(`/api/akuntansi/periode/${prevPeriode}/${status}`); // endpoint sesuai backend
      setMessage('Proses ke bulan sebelumnya berhasil!');
      setTimeout(() => {
        localStorage.removeItem('pengguna'); // Hapus data sesi pengguna
        window.location.href = '/login'; // Redirect ke halaman login
      }, 3000);
    } catch(e) {
      console.error(e);
      setMessage('Gagal: ' + (e?.response?.data?.message || e.message));
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card card-info" style={{ width: "400px" }}>
        <div className="card-header text-center" style={{ background: '#17a2b8', color: '#fff' }}>
          <h5 className="card-title">Proses Ke Bulan Sebelumnya</h5>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Periode</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={currentPeriodeDisplay || ''} readOnly />
            </div>
          </div>
          <div className="form-group row mt-3">
            <label className="col-sm-5 col-form-label">Periode Sebelumnya</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={prevPeriodeDisplay || ''} readOnly />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-primary btn-sm" onClick={handleProses} disabled={isSubmitting}>
            {isSubmitting ? 'Memproses...' : 'Proses'}
          </button>
          {message && 
          <div className="alert alert-info mt-2 text-center" role="alert">{message}
          </div>} 
        </div>
      </div>
    </div>
  );
};

export default KeperiodeLalu;
